import axiosAuth from '@/services/axios';
import axiosAuth2 from './axiosAuth2';
import axios from 'axios';
import { AxiosRequestConfig } from 'axios';

class BaseService {
    get<T = unknown>(url: string, data?: unknown) {
        return axiosAuth.get<T>(url, {
            data,
        });
    }

    post<T = unknown>(url: string, data: unknown) {
        return axiosAuth.post<T>(url, data);
    }

    put<T = unknown>(url: string, data: unknown) {
        return axiosAuth.put<T>(url, data);
    }

    delete<T = unknown>(url: string) {
        return axiosAuth.delete<T>(url);
    }

    getAuth2<T = unknown>(url: string, data?: unknown) {
        return axiosAuth2.get<T>(url, {
            data,
        });
    }

    postAuth2<T = unknown>(url: string, data: unknown, config?: AxiosRequestConfig) {
        return axiosAuth2.post<T>(url, data, config);
    }

    putAuth2<T = unknown>(url: string, data: unknown) {
        return axiosAuth2.put<T>(url, data);
    }

    deleteAuth2<T = unknown>(url: string) {
        return axiosAuth2.delete<T>(url);
    }

    all<T = unknown>(requests: Array<Promise<T>>) {
        return axios.all(requests);
    }

    spread<T = unknown>(fn: (...args: T[]) => void) {
        return axios.spread(fn);
    }
}

export default BaseService;
